












































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { AccomodationUnitViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import { Notification } from "../../store/modules/notifications";
import DeferredAutocompleteWrapper from "@/components/misc/DeferredAutocompleteWrapper.vue";
import { DefferedAutocompleteItem } from "@/components/misc/DeferredAutocomplete.vue";
import AccomodationUnitForm from "@/components/property/AccomodationUnitForm.vue";
import { ApiCredential } from "@/shared/models/apiCredential";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";

@Component({
  components: {
    DeferredAutocompleteWrapper,
    AccomodationUnitForm,
  },
})
export default class AccomodationUnitTable extends Vue {
  @Prop({ default: 0 }) accUnitTypeId?: number;
  @Prop({ default: 0 }) ownerId?: number;
  @Prop({ default: 0 }) propertyOwnerPricingModelId?: number | null;
  @Prop({ default: 0 }) propertyOwnerPayoutPercent?: number | null;
  @Prop() propertyId?: number;

  units: AccomodationUnitViewModel[] = [];

  headers = [
    {
      text: "AccomodationUnit.Name",
      value: "name",
    },
    {
      text: "AccomodationUnit.ShortName",
      value: "shortName",
    },
    {
      text: "AccomodationUnit.Owner",
      value: "ownerName",
    },
    {
      text: "Floor",
      value: "floor",
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      width: "150",
      align: "center",
    },
  ];

  openApiKeySelection = false;
  selected: ApiCredential[] = [];
  apiCredentialsHeaders = [
    {
      text: 'Name',
      align: 'start',
      sortable: false,
      value: 'name'
    },
    { text: 'Username', 
      value: 'userTenantUsername',
      sortable: false
    },
  ];
  get translatedHeaders() {
    return this.headers.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  @Watch("accUnitTypeId")
  accUnitTypeIdWatch() {
    this.load();
  }

  async mounted() {
    this.load();
    await this.loadApiCredentials();
  }

  load() {
    if (this.accUnitTypeId) {
      Vue.axios
        .get<ListModel<AccomodationUnitViewModel>>("AccomodationUnits", {
          params: {
            $skip: 0,
            $top: 100,
            $count: true,
            accomodationUnitTypeId: this.accUnitTypeId,
          },
        })
        .then((res) => {
          this.units = res.data.result;

          if (res.data.count && this.units.length < res.data.count) {
            this.loadMore();
          }
        });
    }
  }

  loadMore() {
    Vue.axios
      .get<ListModel<AccomodationUnitViewModel>>("AccomodationUnits", {
        params: {
          $skip: this.units.length,
          $top: 100,
          $count: true,
          accomodationUnitTypeId: this.accUnitTypeId,
        },
      })
      .then((res) => {
        this.units.push(...res.data.result);

        if (res.data.count && this.units.length < res.data.count) {
          this.loadMore();
        }
      });
  }

  accomodationUnitFormOpen = false;
  accomodationUnit: AccomodationUnitViewModel = new AccomodationUnitViewModel();
  loading = false;

  rowDoubleClick(e: MouseEvent, { item }: { item: AccomodationUnitViewModel }) {
    this.openItemDetails(item);
  }
  async openItemDetails(item: AccomodationUnitViewModel) {
    await this.loadAccomodationUnit(item.id);
    this.accomodationUnitFormOpen = true;
  }

  addUnit(
    propertyAgencyWorkModel: number,
    propertyVATCategory: number | null,
    propertyOwnerPriceOffset: number | null,
    propertyAgencyCommissionPercentForPrepayments: number | null,
    propertyOwnerDoesCheckin = false,
    propertyOwnerDoesCheckout = false,
    propertyOwnerDoesCleaning = false,
    propertyCategorizationNumber: string | null,
    propertyCategorizationClass: string | null,
    propertyCategorizationDate: Date | null = null
  ) {
    this.accomodationUnit = new AccomodationUnitViewModel();
    this.accomodationUnit.agencyWorkModelId = propertyAgencyWorkModel;
    this.accomodationUnit.accomodationUnitTypeId = this.accUnitTypeId;
    this.accomodationUnit.vatCategoryForPrepaymentsId = propertyVATCategory;
    this.accomodationUnit.ownerPriceOffset = propertyOwnerPriceOffset;
    this.accomodationUnit.agencyCommissionPercentForPrepayments = propertyAgencyCommissionPercentForPrepayments;
    this.accomodationUnit.ownerDoesCheckin = propertyOwnerDoesCheckin;
    this.accomodationUnit.ownerDoesCheckout = propertyOwnerDoesCheckout;
    this.accomodationUnit.ownerDoesCleaning = propertyOwnerDoesCleaning;
    this.accomodationUnit.categorizationNumber = propertyCategorizationNumber;
    this.accomodationUnit.categorizationClass = propertyCategorizationClass;
    this.accomodationUnit.categorizationDate = propertyCategorizationDate;
    this.setDefaultOwner();
    this.accomodationUnitFormOpen = true;
  }

  loadAccomodationUnit(id: number) {
    this.loading = true;
    return this.axios
      .get<AccomodationUnitViewModel>("/AccomodationUnits/" + id)
      .then((res) => {
        this.accomodationUnit = {
          ...new AccomodationUnitViewModel(),
          ...res.data,
        };
        this.accomodationUnit.paysCityTax =
          res.data.paysCityTax == true || res.data.paysCityTax == false
            ? res.data.paysCityTax
            : null;
        this.accomodationUnit.accomodationUnitTypeId = this.accUnitTypeId;
      })
      .finally(() => (this.loading = false));
  }

  deleteItem(item: AccomodationUnitViewModel) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${item?.name}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item.id);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteItemConfirm(id: number | undefined) {
    if (!id) {
      return;
    }
    this.loading = true;
    Vue.axios
      .delete(`/AccomodationUnits/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("AccomodationUnit.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.load();
        this.loading = false;
      });
  }

  setDefaultOwner() {
    if (this.ownerId) {
      this.accomodationUnit.ownerId = this.ownerId;
      this.customerFetch({ id: this.ownerId });
    }
  }

  isById(x: any): x is { id: number } {
    return x && (x as { id: number }).id !== undefined;
  }

  isBySearch(x: any): x is { search: string } {
    return x && !!(x as { search: string }).search;
  }

  customerFetch(
    val: { id: number } | { search: string }
  ): Promise<DefferedAutocompleteItem[]> {
    if (this.isById(val)) {
      return this.axios.get<any>(`customers/${val.id}`).then(({ data }) => [
        {
          id: data.id,
          text: data.isLegalEntity
            ? data.legalEntityName
            : // prettier-ignore
              `${data.firstName}${data.middleName ? ' '+ data.middleName : ''} ${data.lastName}`,
        },
      ]);
    } else if (this.isBySearch(val)) {
      return this.axios
        .get<ListModel<any>>("customers", {
          params: {
            $orderby: "name",
            name: val.search,
          },
        })
        .then(({ data }) =>
          data.result.map((x) => ({
            id: x.id,
            text: x.name,
          }))
        );
    } else {
      return Promise.resolve([]);
    }
  }

  async copyiCalendarLink(unitId: number) {
    if(typeof ClipboardItem && navigator.clipboard.write) {
      // Safari locks down the clipboard API to only work when triggered by a direct user interaction. 
      // We can't use it async in a promise, but we can wrap the promise in a ClipboardItem, and give that to the clipboard API.
      // reference: https://developer.apple.com/forums/thread/691873
      navigator.clipboard.write(
        [
          new ClipboardItem({
            "text/plain": this.fetchICalLink(unitId)
              .then(response => response)
              .then(text => new Blob([text], { type: "text/plain" }))
          })
        ]
      )
    }
    else {
      // Firefox has support for ClipboardItem and navigator.clipboard.write, but those are behind `dom.events.asyncClipboard.clipboardItem` preference.
      // On the other hand... Firefox can do this the "standard" way.
      navigator.clipboard.writeText(await this.fetchICalLink(unitId));
    }

    this.openApiKeySelection = false;
    this.selected = [];
    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  async fetchICalLink(unitId: number){
    let result = '';

    await this.axios
      .get("accomodationUnits/GetICalLink?id=" + unitId + '&key=' + this.selected[0].id, {})
      .then((res) => {
        result = res.data;
      });

    return result;
  }

  list: ListModel<ApiCredential> = {
    count: 0,
    result: [],
  };

  async loadApiCredentials(): Promise<ListModel<ApiCredential>> {
    this.loading = true;
    
    return (
      this.axios
        .get<ListModel<ApiCredential>>("/ApiCredentials", {
          params: this.queryParams,
        })
        .then((res) => {
          this.list.result = res.data.result.filter(x => x.name.includes('iCal'));
          this.list.count = this.list.result.length;

          return this.list;
        })
        .finally(() => {
          this.loading = false;
        })
    );
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["name"],
    sortDesc: [false],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };
  
  get queryParams() {
    return {
      $skip: 0,
      $top: 100,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true
    };
  }

  async checkApiKeys(item: AccomodationUnitViewModel){
    if(!this.list.count){
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("ApiKey.iCal.AtLease1KeyRequired"),
        timeout: 10000,
      });
    }
    else if(this.list.count && this.list.count > 1){
      this.openApiKeySelection = true
    }
    else{
      this.selected[0] = this.list.result[0]; 
      this.copyiCalendarLink(item.id);
    }
  }
}
